export const contattiAsl = {
    asl3: {
        contatti: "Per necessità di supporto o assistenza, inviare una mail all'indirizzo di posta elettronica screeningcolonretto@asl3.liguria.it",
        informazioni: {
            intro: "Per maggiori informazioni sul servizio visitare i seguenti link:",
            list: [
                {
                    pretext: "Per informazioni relative a sedi, orari e modalità delle campagne di screening, visitare ",
                    link: "https://www.asl3.liguria.it/valutazione-organizzazione-screening",
                    linkTitle: " www.asl3.liguria.it/valutazione-organizzazione-screening"
                },
                {
                    pretext: "Per informazioni relative allo screening del colon retto e alle farmacie aderenti, visitare ",
                    link: "https://www.asl3.liguria.it/valutazione-organizzazione-screening/tumore-colon-retto.html",
                    linkTitle: " www.asl3.liguria.it/valutazione-organizzazione-screening/tumore-colon-retto.html"
                }
            ]
        }
    },
    asl5: {
        contatti: "Per necessità di supporto o assistenza, inviare una mail all'indirizzo di posta elettronica screening@asl5.liguria.it oppure lasciare un messaggio alla casella vocale 0187 534295 ed aspettare di essere ricontattati da un operatore.",
        informazioni: {
            intro: "Per maggiori informazioni sul servizio visitare i seguenti link:",
            list: [
                {
                    pretext: "Per informazioni relative alle campagne di screening, visitare ",
                    link: "https://www.asl5.liguria.it/PerilCittadino/PREVENZIONEESCREENING.aspx",
                    linkTitle: " www.asl5.liguria.it/PerilCittadino/PREVENZIONEESCREENING.aspx"
                },
                {
                    pretext: "Scarica l'",
                    link: "https://www.asl5.liguria.it/Portals/0/PerIlCittadino/20250204_opuscolo%20informativo%20farmacie.pdf",
                    linkTitle: "opuscolo informativo",
                    postText: " dello screening del colon retto in formato pdf."
                },
                {
                    pretext: "Consulta il documento '100 domande sullo screening del colon retto' sul sito dell’Osservatorio Nazionale Screening ",
                    link: "https://www.osservatorionazionalescreening.it/node/67",
                    linkTitle: "www.osservatorionazionalescreening.it/node/67",
                    postText: ""
                }
            ]
        }
    },
}